import { 
  CuttingOrder, 
  CuttingOrderLine, 
  CutConfig, 
  CutConfigLine, 
   
} from '@/types/cutting';

export const mockCutConfigs: CutConfig[] = [
  {
    id: 'CFG001',
    name: 'MDF 1200x800x18mm - Tủ bếp',
    cutType: 'cut_wood',
    materialType: 'MDF',
    description: 'Cấu hình cắt cho tủ bếp tiêu chuẩn',
    createdBy: 'Nguyễn Văn A',
    usageCount: 15,
    cutConfigLines: [],
    createdAt: '2024-01-10T08:00:00Z',
    updatedAt: '2024-01-20T16:30:00Z',
  },
  {
    id: 'CFG002',
    name: 'Mica 600x400x3mm - Trang trí',
    cutType: 'cut_mica',
    materialType: 'Mica',
    description: 'Cấu hình cắt mica trang trí',
    createdBy: 'Trần Thị B',
    usageCount: 8,
    cutConfigLines: [],
    createdAt: '2024-01-12T09:30:00Z',
    updatedAt: '2024-01-18T14:15:00Z',
  },
  {
    id: 'CFG003',
    name: 'Thép 2000x1000x5mm - Khung',
    cutType: 'cut_metal',
    materialType: 'Thép',
    description: 'Cấu hình cắt khung thép',
    createdBy: 'Lê Văn C',
    usageCount: 12,
    cutConfigLines: [],
    createdAt: '2024-01-08T10:15:00Z',
    updatedAt: '2024-01-22T11:45:00Z',
  },
  {
    id: 'CFG004',
    name: 'Gỗ sồi 1500x900x20mm - Bàn',
    cutType: 'cut_wood',
    materialType: 'Gỗ sồi',
    description: 'Cấu hình cắt mặt bàn gỗ sồi',
    createdBy: 'Phạm Thị D',
    usageCount: 6,
    cutConfigLines: [],
    createdAt: '2024-01-15T13:20:00Z',
    updatedAt: '2024-01-19T09:30:00Z',
  },
  {
    id: 'CFG005',
    name: 'Nhựa acrylic 800x600x5mm - Biển hiệu',
    cutType: 'cut_plastic',
    materialType: 'Nhựa acrylic',
    description: 'Cấu hình cắt biển hiệu nhựa',
    createdBy: 'Hoàng Văn E',
    usageCount: 10,
    cutConfigLines: [],
    createdAt: '2024-01-05T15:45:00Z',
    updatedAt: '2024-01-21T12:20:00Z',
  },
];

export const mockCutConfigLines: CutConfigLine[] = [
  // CFG001 - MDF Tủ bếp
  {
    id: 'CL001',
    cutConfigId: 'CFG001',
    finalSize: '1200x800x18mm',
    quantity: 2,
    unit: 'tấm',
    notes: 'Mặt tủ chính',
    createdAt: '2024-01-10T08:00:00Z',
    updatedAt: '2024-01-10T08:00:00Z',
  },
  {
    id: 'CL002',
    cutConfigId: 'CFG001',
    finalSize: '600x400x18mm',
    quantity: 4,
    unit: 'tấm',
    notes: 'Cánh tủ nhỏ',
    createdAt: '2024-01-10T08:00:00Z',
    updatedAt: '2024-01-10T08:00:00Z',
  },
  {
    id: 'CL003',
    cutConfigId: 'CFG001',
    finalSize: '1180x380x18mm',
    quantity: 3,
    unit: 'tấm',
    notes: 'Ngăn kéo',
    createdAt: '2024-01-10T08:00:00Z',
    updatedAt: '2024-01-10T08:00:00Z',
  },
  // CFG002 - Mica trang trí
  {
    id: 'CL004',
    cutConfigId: 'CFG002',
    finalSize: '600x400x3mm',
    quantity: 10,
    unit: 'tấm',
    notes: 'Tấm trang trí chính',
    createdAt: '2024-01-12T09:30:00Z',
    updatedAt: '2024-01-12T09:30:00Z',
  },
  {
    id: 'CL005',
    cutConfigId: 'CFG002',
    finalSize: '300x200x3mm',
    quantity: 20,
    unit: 'tấm',
    notes: 'Tấm trang trí nhỏ',
    createdAt: '2024-01-12T09:30:00Z',
    updatedAt: '2024-01-12T09:30:00Z',
  },
  // CFG003 - Thép khung
  {
    id: 'CL006',
    cutConfigId: 'CFG003',
    finalSize: '2000x1000x5mm',
    quantity: 1,
    unit: 'tấm',
    notes: 'Khung chính',
    createdAt: '2024-01-08T10:15:00Z',
    updatedAt: '2024-01-08T10:15:00Z',
  },
  {
    id: 'CL007',
    cutConfigId: 'CFG003',
    finalSize: '1000x500x5mm',
    quantity: 4,
    unit: 'tấm',
    notes: 'Khung phụ',
    createdAt: '2024-01-08T10:15:00Z',
    updatedAt: '2024-01-08T10:15:00Z',
  },
  // CFG004 - Gỗ sồi bàn
  {
    id: 'CL008',
    cutConfigId: 'CFG004',
    finalSize: '1500x900x20mm',
    quantity: 1,
    unit: 'tấm',
    notes: 'Mặt bàn chính',
    createdAt: '2024-01-15T13:20:00Z',
    updatedAt: '2024-01-15T13:20:00Z',
  },
  {
    id: 'CL009',
    cutConfigId: 'CFG004',
    finalSize: '700x200x20mm',
    quantity: 2,
    unit: 'tấm',
    notes: 'Chân bàn',
    createdAt: '2024-01-15T13:20:00Z',
    updatedAt: '2024-01-15T13:20:00Z',
  },
  // CFG005 - Nhựa acrylic biển hiệu
  {
    id: 'CL010',
    cutConfigId: 'CFG005',
    finalSize: '800x600x5mm',
    quantity: 1,
    unit: 'tấm',
    notes: 'Biển hiệu chính',
    createdAt: '2024-01-05T15:45:00Z',
    updatedAt: '2024-01-05T15:45:00Z',
  },
  {
    id: 'CL011',
    cutConfigId: 'CFG005',
    finalSize: '400x300x5mm',
    quantity: 2,
    unit: 'tấm',
    notes: 'Biển hiệu phụ',
    createdAt: '2024-01-05T15:45:00Z',
    updatedAt: '2024-01-05T15:45:00Z',
  },
];

export const mockCuttingOrders: CuttingOrder[] = [
  {
    id: 'CO001',
    code: 'LC001',
    date: '2024-01-22',
    createdBy: 'Nguyễn Văn A',
    notes: 'Lệnh cắt cho dự án tủ bếp khách hàng ABC',
    status: 'created',
    cutLines: [],
    totalQuantity: 9,
    totalConfigs: 1,
    createdAt: '2024-01-22T08:30:00Z',
    updatedAt: '2024-01-22T08:30:00Z',
  },
  {
    id: 'CO002',
    code: 'LC002',
    date: '2024-01-21',
    createdBy: 'Trần Thị B',
    notes: 'Lệnh cắt mica trang trí showroom',
    status: 'cut',
    cutLines: [],
    totalQuantity: 30,
    totalConfigs: 1,
    createdAt: '2024-01-21T09:15:00Z',
    updatedAt: '2024-01-21T14:30:00Z',
  },
  {
    id: 'CO003',
    code: 'LC003',
    date: '2024-01-20',
    createdBy: 'Lê Văn C',
    notes: 'Lệnh cắt khung thép công trình XYZ',
    status: 'confirmed',
    cutLines: [],
    totalQuantity: 5,
    totalConfigs: 1,
    createdAt: '2024-01-20T10:45:00Z',
    updatedAt: '2024-01-20T16:20:00Z',
  },
  {
    id: 'CO004',
    code: 'LC004',
    date: '2024-01-19',
    createdBy: 'Phạm Thị D',
    notes: 'Lệnh cắt mặt bàn gỗ sồi',
    status: 'confirmed',
    cutLines: [],
    totalQuantity: 3,
    totalConfigs: 1,
    createdAt: '2024-01-19T11:20:00Z',
    updatedAt: '2024-01-19T15:45:00Z',
  },
  {
    id: 'CO005',
    code: 'LC005',
    date: '2024-01-18',
    createdBy: 'Hoàng Văn E',
    notes: 'Lệnh cắt biển hiệu nhựa',
    status: 'cut',
    cutLines: [],
    totalQuantity: 3,
    totalConfigs: 1,
    createdAt: '2024-01-18T13:30:00Z',
    updatedAt: '2024-01-18T17:15:00Z',
  },
  {
    id: 'CO006',
    code: 'LC006',
    date: '2024-01-17',
    createdBy: 'Nguyễn Văn A',
    notes: 'Lệnh cắt thử nghiệm',
    status: 'created',
    cutLines: [],
    totalQuantity: 5,
    totalConfigs: 2,
    createdAt: '2024-01-17T14:20:00Z',
    updatedAt: '2024-01-17T14:20:00Z',
  },
];

export const mockCuttingOrderLines: CuttingOrderLine[] = [
  // CO001 - Tủ bếp
  {
    id: 'COL001',
    cuttingOrderId: 'CO001',
    stt: 1,
    materialName: 'MDF 18mm',
    cutType: 'cut_wood',
    quantity: 2,
    unit: 'tấm',
    text: 'Mặt tủ chính 1200x800',
    cutConfigId: 'CFG001',
    createdAt: '2024-01-22T08:30:00Z',
    updatedAt: '2024-01-22T08:30:00Z',
  },
  {
    id: 'COL002',
    cuttingOrderId: 'CO001',
    stt: 2,
    materialName: 'MDF 18mm',
    cutType: 'cut_wood',
    quantity: 4,
    unit: 'tấm',
    text: 'Cánh tủ nhỏ 600x400',
    cutConfigId: 'CFG001',
    createdAt: '2024-01-22T08:30:00Z',
    updatedAt: '2024-01-22T08:30:00Z',
  },
  {
    id: 'COL003',
    cuttingOrderId: 'CO001',
    stt: 3,
    materialName: 'MDF 18mm',
    cutType: 'cut_wood',
    quantity: 3,
    unit: 'tấm',
    text: 'Ngăn kéo 1180x380',
    cutConfigId: 'CFG001',
    createdAt: '2024-01-22T08:30:00Z',
    updatedAt: '2024-01-22T08:30:00Z',
  },
  // CO002 - Mica trang trí
  {
    id: 'COL004',
    cuttingOrderId: 'CO002',
    stt: 1,
    materialName: 'Mica 3mm',
    cutType: 'cut_mica',
    quantity: 10,
    unit: 'tấm',
    text: 'Tấm trang trí chính 600x400',
    cutConfigId: 'CFG002',
    createdAt: '2024-01-21T09:15:00Z',
    updatedAt: '2024-01-21T09:15:00Z',
  },
  {
    id: 'COL005',
    cuttingOrderId: 'CO002',
    stt: 2,
    materialName: 'Mica 3mm',
    cutType: 'cut_mica',
    quantity: 20,
    unit: 'tấm',
    text: 'Tấm trang trí nhỏ 300x200',
    cutConfigId: 'CFG002',
    createdAt: '2024-01-21T09:15:00Z',
    updatedAt: '2024-01-21T09:15:00Z',
  },
  // CO003 - Khung thép
  {
    id: 'COL006',
    cuttingOrderId: 'CO003',
    stt: 1,
    materialName: 'Thép 5mm',
    cutType: 'cut_metal',
    quantity: 1,
    unit: 'tấm',
    text: 'Khung chính 2000x1000',
    cutConfigId: 'CFG003',
    createdAt: '2024-01-20T10:45:00Z',
    updatedAt: '2024-01-20T10:45:00Z',
  },
  {
    id: 'COL007',
    cuttingOrderId: 'CO003',
    stt: 2,
    materialName: 'Thép 5mm',
    cutType: 'cut_metal',
    quantity: 4,
    unit: 'tấm',
    text: 'Khung phụ 1000x500',
    cutConfigId: 'CFG003',
    createdAt: '2024-01-20T10:45:00Z',
    updatedAt: '2024-01-20T10:45:00Z',
  },
  // CO004 - Bàn gỗ sồi
  {
    id: 'COL008',
    cuttingOrderId: 'CO004',
    stt: 1,
    materialName: 'Gỗ sồi 20mm',
    cutType: 'cut_wood',
    quantity: 1,
    unit: 'tấm',
    text: 'Mặt bàn chính 1500x900',
    cutConfigId: 'CFG004',
    createdAt: '2024-01-19T11:20:00Z',
    updatedAt: '2024-01-19T11:20:00Z',
  },
  {
    id: 'COL009',
    cuttingOrderId: 'CO004',
    stt: 2,
    materialName: 'Gỗ sồi 20mm',
    cutType: 'cut_wood',
    quantity: 2,
    unit: 'tấm',
    text: 'Chân bàn 700x200',
    cutConfigId: 'CFG004',
    createdAt: '2024-01-19T11:20:00Z',
    updatedAt: '2024-01-19T11:20:00Z',
  },
  // CO005 - Biển hiệu nhựa
  {
    id: 'COL010',
    cuttingOrderId: 'CO005',
    stt: 1,
    materialName: 'Nhựa acrylic 5mm',
    cutType: 'cut_plastic',
    quantity: 1,
    unit: 'tấm',
    text: 'Biển hiệu chính 800x600',
    cutConfigId: 'CFG005',
    createdAt: '2024-01-18T13:30:00Z',
    updatedAt: '2024-01-18T13:30:00Z',
  },
  {
    id: 'COL011',
    cuttingOrderId: 'CO005',
    stt: 2,
    materialName: 'Nhựa acrylic 5mm',
    cutType: 'cut_plastic',
    quantity: 2,
    unit: 'tấm',
    text: 'Biển hiệu phụ 400x300',
    cutConfigId: 'CFG005',
    createdAt: '2024-01-18T13:30:00Z',
    updatedAt: '2024-01-18T13:30:00Z',
  },
];

// Link cut config lines to configs
mockCutConfigs.forEach(config => {
  config.cutConfigLines = mockCutConfigLines.filter(line => line.cutConfigId === config.id);
});

// Link cutting order lines to orders
mockCuttingOrders.forEach(order => {
  order.cutLines = mockCuttingOrderLines.filter(line => line.cuttingOrderId === order.id);
});
